import React from 'react';
import { Clock } from 'lucide-react';
import { Button } from './ui';
import { trackInitiateCheckout } from './useMetaPixel';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL, prices } from '../data/kit';
export function Pricing() {
  const {
    units,
    remainingRatio
  } = useCountdown({
    h: 23,
    m: 58,
    s: 40
  });
  return <>
      <section className="w-full bg-wine-dark px-4 py-14 md:py-20" data-id="element-162" data-mp="2jke84k2mukvm">
        <div className="max-w-3xl mx-auto" data-id="element-163" data-mp="1vv39b84uf0k4">
          <p className="flex items-center justify-center gap-2.5 text-center text-white font-black tracking-tight text-lg sm:text-3xl" data-id="element-164" data-mp="1vvv26b722k6p">
            <Clock className="w-6 h-6 sm:w-8 sm:h-8 shrink-0 text-rose-400" data-id="element-165" data-mp="25shmmyvgz987" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </p>

          <div className="mt-8 flex items-start justify-center gap-3 sm:gap-8" role="timer" data-id="element-166" data-mp="20rtkbh1sj5yo">
            {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-167" data-mp="3c8a2hi4qc0p8" data-mpi={i}>
                {i > 0 && <span className="text-rose-700 font-black text-5xl sm:text-8xl leading-none" aria-hidden="true" data-id="element-168" data-mp="3caeaab5r1jus">
                    :
                  </span>}
                <div className="text-center" data-id="element-169" data-mp="4rkubwmqq74x">
                  <p className="tabular-nums font-black text-rose-400 text-6xl sm:text-8xl leading-none" data-id="element-170" data-mp="9sia62ka2p39">
                    {String(unit.value).padStart(2, '0')}
                  </p>
                  <p className="mt-3 text-[11px] sm:text-sm font-semibold tracking-[0.3em] text-rose-100/60" data-id="element-171" data-mp="3d8z47xrngvi9">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-9 text-center text-base sm:text-lg text-white" data-id="element-172" data-mp="3n6d70uknhls3">
            ⚠️ Después vuelve a{' '}
            <span className="font-black text-rose-300" data-id="element-173" data-mp="3rzenv84f3veb">{prices.before}</span>. No vuelve.
          </p>

          <div className="mt-9" data-id="element-174" data-mp="2uhy3b46yypw2">
            <div className="flex items-center justify-between text-sm" data-id="element-175" data-mp="2zhkk1nm0ao9m">
              <span className="text-rose-50/80 font-medium" data-id="element-176" data-mp="2zfpzwbik706l">🔴 Precio de lanzamiento</span>
              <span className="text-rose-300 font-bold" data-id="element-177" data-mp="2rfa2lgnznzc6">Por tiempo limitado</span>
            </div>
            <div className="w-full mt-3 bg-white/10 rounded-full h-3 overflow-hidden" data-id="element-178" data-mp="2mh8l3067o82t">
              <div className="h-full rounded-full bg-rose-500 transition-[width] duration-1000 ease-linear" style={{
              width: `${Math.max(2, remainingRatio * 100)}%`
            }} data-id="element-179" data-mp="315czhry8dxfs"></div>
            </div>
            <p className="text-xs text-rose-100/60 mt-3 text-center" data-id="element-180" data-mp="28jtrrkcu7g5k">
              Al terminar el contador el Kit vuelve a {prices.before}.
            </p>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 bg-rose-50 border-b border-rose-200" id="planes" data-id="element-181" data-mp="2idtxnofy0pfc">
        <div className="max-w-lg mx-auto" data-id="element-182" data-mp="2djg6jy8bd4gh">
          <h2 className="font-serif text-[23px] md:text-4xl font-bold text-center text-wine leading-[1.15] tracking-tight mb-6 md:mb-8" data-id="element-183" data-mp="3tuae9l38hc3s">
            DEJÁ DE BUSCAR RESPUESTAS SUELTAS Y{' '}
            <span className="text-rose-600" data-id="element-184" data-mp="a43xsc3ewpg">EMPEZÁ A ENTENDER ESTA ETAPA</span>
          </h2>

          <div className="max-w-md mx-auto rounded-3xl border-2 border-rose-500 bg-white p-5 sm:p-6 text-center shadow-[0_24px_55px_-24px_rgba(148,64,76,0.6)]" data-id="element-185" data-mp="5a00j6ignluz">
            <h3 className="font-black text-wine text-lg sm:text-xl tracking-tight leading-tight" data-id="element-186" data-mp="3nhfxpx7wfom6">
              🌿 KIT MENOPAUSIA + PERIMENOPAUSIA
            </h3>
            <p className="text-sm text-rose-600 font-bold mt-1" data-id="element-187" data-mp="j26cshiht8p5">5 Guías + 3 Bonos</p>
            <span className="inline-block mt-2 bg-wine text-white text-[9px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 rounded-full" data-id="element-188" data-mp="nywrp1ik9y8z">
              Oferta de lanzamiento
            </span>
            <p className="text-xs text-ink-muted leading-snug mt-3 max-w-xs mx-auto" data-id="element-189" data-mp="e93ha3u5np6b">
              En solo 7 días vas a poder entender mejor qué cambios estás
              atravesando, qué te afecta más y por dónde empezar.
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-ink-soft mt-4" data-id="element-190" data-mp="16sk76eojvjmw">
              Antes <span className="line-through text-rose-600" data-id="element-191" data-mp="3f5fl6x6dir6n">{prices.before}</span>
            </p>
            <p className="text-5xl sm:text-6xl font-black text-wine leading-none tracking-tight mt-1" data-id="element-192" data-mp="3aaidpuoqspvv">
              {prices.now}
            </p>
            <p className="text-xs text-ink-muted mt-3" data-id="element-193" data-mp="318ivx05wlhrv">✓ Pago único</p>
            <Button className="w-full mt-4 text-base py-4" onClick={() => {
            trackInitiateCheckout();
            window.location.href = CHECKOUT_URL;
          }} data-id="element-194" data-mp="1sm8r08wptc7">
              QUIERO EMPEZAR MI PLAN +40
            </Button>
          </div>

          <p className="text-center text-xs text-ink-soft mt-4" data-id="element-195" data-mp="3k6lht635mylg">
            Garantía 7 días · Pago seguro · Acceso inmediato · 100% digital
          </p>
        </div>
      </section>
    </>;
}